import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PageNavBar } from '../cmps/nav-header/page-nav-bar'

export const AwsPage: React.FC = () => {
    const location = useLocation()

    if (location.pathname === '/AWS') {
        return <Navigate to="/AWS/glue-triggers" replace />
    }

    return <section className="database-page page-content-padding">
        <PageNavBar mainPage='aws' />
        <Outlet />
    </section>
}
